import React, { useEffect, useMemo, useState } from "react";
import { View } from "react-native";
import { AppText, AppIcon } from "@toothfairy/shared-ui";
import { useHistory } from "../../../Router";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import useWorkspaces from "../../../Hooks/useWorkspaces";
import usePath from "../../../Hooks/usePath";
import { useTranslation } from "react-i18next";

const ArenaHeader = ({ ...props }) => {
  const { getActiveWorkspace } = useWorkspaces();
  const path = usePath();

  is_in_leaderboard =
    path?.path?.path === "/workspaces/:workspaceId/arena_leaderboard";
  const { t } = useTranslation();
  const [backRoute, setBackRoute] = useState({
    label: t("arena.header.viewLeaderboard"),
    route: `/workspaces/${getActiveWorkspace()?.id}/arena_leaderboard`,
  });
  useEffect(() => {
    if (getActiveWorkspace()?.id)
      if (is_in_leaderboard) {
        setBackRoute({
          label: t("arena.header.backToArena"),
          route: `/workspaces/${getActiveWorkspace()?.id}/arena`,
        });
      } else {
        setBackRoute({
          label: t("arena.header.viewLeaderboard"),
          route: `/workspaces/${getActiveWorkspace()?.id}/arena_leaderboard`,
        });
      }
  }, [is_in_leaderboard, getActiveWorkspace()?.id]);
  const currentRoute = {
    label: t("arena.title"),
  };
  const { currentTheme } = AppTheme.useTheme();
  const history = useHistory();
  const _appLogo = useMemo(
    () => (
      <AppIcon
        style={{
          paddingVertical: 10,
          paddingRight: 5,
          width: 152,
          marginLeft: 5,
        }}
        imageSource={require("../../../assets/logoTitle.png")}
        width={"100%"}
        size={36}
        isClickable
        onPress={() => {
          window.open("https://toothfairyai.com", "_blank");
        }}
      />
    ),
    [],
  );

  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottomColor: currentTheme?.theme?.primary_medium,
        borderBottomWidth: 1,
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <AppText
          iconSize={16}
          leftIcon={AppAssets?.icons?.arena}
          color={currentTheme?.theme?.primary}
          style={{
            fontSize: currentTheme?.theme?.normal_font_size,
            fontWeight: "bold",
            paddingLeft: 10,
          }}
          wrapperStyle={{
            padding: 10,
          }}
        >
          {currentRoute?.label}
        </AppText>
      </View>

      <AppText
        style={{
          fontSize: currentTheme?.theme?.normal_font_size,
          fontWeight: "bold",
          color: currentTheme?.theme?.primary,
          padding: 10,
        }}
        isClickable
        onPress={() => {
          history.push(backRoute?.route);
        }}
      >
        {backRoute?.label}
      </AppText>
    </View>
  );
};

export default ArenaHeader;
